import React from 'react'
import { Handle } from 'rc-slider';
import Tooltip from 'rc-tooltip';

class SliderTooltip extends React.Component {
  state = {
    visible: false
  };

  mouseEnter = () => {
    this.setState({ visible: true });
  };

  mouseLeave = () => { 
    this.setState({ visible: false });
  }

  render() {
    const { value, dragging, index, format, ...rest } = this.props;
  
    return (
      <Tooltip
        prefixCls='rc-slider-tooltip'
        overlay={ format() }
        visible={ dragging || this.state.visible }
        value={value}
        placement='top'
        key={ index }
      >
        <Handle 
          key={ index }
          value={ value }
          onMouseEnter={ this.mouseEnter } 
          onMouseLeave={ this.mouseLeave } 
          { ...rest }
        />
      </Tooltip>
    )
  }
};

export default SliderTooltip
